import React from 'react'
import services from 'core/services'

export default (ns, lng) => {
  const tr = services.translation
  let t = tr.t

  if (ns || lng) {
    t = tr.getFixedT(lng, ns)
  }

  return Component => props => <Component {...props} t={t} translator={tr} lng={tr.language} dir={tr.dir()}/>
}
